import styled from 'styled-components';

export const StyledFeeSections = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${({ theme }) => theme.spacing.spacing6};
`;
